import { postApi } from 'api/fetchApi'

export const updateCoordinatesApi = (lat: number, lng: number) =>
  postApi('/profiles/my/coords', {
    lat,
    lng,
  })
